import * as React from "react";
import { ProductTile } from "@arctheme-components/ecommerce/Product/ProductTile";
import { SearchBlogArticleTile } from "./SearchBlogArticleTile";

export const HeaderSearchResults = ({ settings, results, type }) => {
  if (!results || results.length === 0) {
    return null;
  }
  
  return (
    <>
      {type === "products" &&
        results.map((product) => (
          <div className="search-tile" key={product.id}>
            <ProductTile
              settings={settings}
              product={product}
              siblings={undefined}
              showQuickAdd={false}
              showInfo={true}
            />
          </div>
        ))}
      {type === "articles" &&
        results.map((article) => (
          <div className="search-article-tile" key={article.id ? article.id : article.objectID}>
            <SearchBlogArticleTile
              article={article}
            />
          </div>
        ))}
    </>
  );
};

export default HeaderSearchResults;
